var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVisibilityBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icVisibilityBlue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.250980392   0 0 0 0 0.639215686   0 0 0 0 0.980392157  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Get-Plus-",
    transform: "translate(-9.000000, -778.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 505.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icVisibilityBlue",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hide_Mode",
    transform: "translate(13.000000, 15.000000)",
    fill: "#40A3FA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3210598,6.80062063 C20.4441998,5.93462786 19.4612815,5.21255483 18.4023687,4.64182436 L22.3895764,0.704031506 C22.5528394,0.542791899 22.5528394,0.282169312 22.3895764,0.120929705 C22.2263134,-0.0403099017 21.9624203,-0.0403099017 21.7991573,0.120929705 L17.6148649,4.25295237 C15.973884,3.51067285 14.1771561,3.11767708 12.3182129,3.11767708 C8.91724871,3.11767708 5.72005011,4.42532616 3.31536593,6.80062063 L0,10.0748981 L3.3980413,13.4308262 C4.24274977,14.265066 5.18683571,14.9644582 6.201488,15.5248793 L2.38297145,19.2960716 C2.21970847,19.4573112 2.21970847,19.7179338 2.38297145,19.8791734 C2.46439417,19.959587 2.57128758,20 2.67818099,20 C2.7850744,20 2.89196781,19.959587 2.97339053,19.8791734 L6.97897054,15.9232359 C8.6533556,16.702217 10.4947616,17.1133574 12.4004707,17.1133574 C15.8014349,17.1133574 18.9986335,15.8057083 21.4033176,13.4304139 L24.7191011,10.1557241 L21.3210598,6.80062063 Z M6.81487246,14.9195091 C5.78727604,14.3784698 4.8352566,13.684026 3.98846037,12.8477244 L1.18083814,10.0748981 L3.90620255,7.38331005 C6.15305193,5.16430666 9.14063923,3.94201972 12.3182129,3.94201972 C13.9479198,3.94201972 15.5262678,4.26532369 16.9818555,4.87811667 L6.81487246,14.9195091 Z M21.0336048,12.8477244 C18.7867555,15.0667278 15.7991681,16.2890148 12.6215945,16.2890148 C10.9451217,16.2890148 9.32293068,15.9455043 7.83310377,15.298484 L18.0050974,5.25255545 C19.078207,5.80225467 20.0723992,6.51525539 20.951347,7.38372243 L23.7589692,10.1565488 L21.0336048,12.8477244 Z",
    id: "Shape",
    stroke: "#40A3FA",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3249333,4.94382022 C9.49416764,4.94382022 7.19101124,7.3127811 7.19101124,10.2244257 C7.19101124,11.2573934 7.48522446,12.2188698 7.9855844,13.0337079 L15.0561798,5.76109548 C14.2639761,5.24643954 13.3292074,4.94382022 12.3249333,4.94382022 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43820225,14.4237642 C10.2382885,14.9639481 11.1932302,15.2808989 12.2197338,15.2808989 C15.022773,15.2808989 17.3033708,12.9351412 17.3033708,10.0520151 C17.3033708,8.9961828 16.9952242,8.0139571 16.4700454,7.19101124 L9.43820225,14.4237642 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisibilityBlue);
export default __webpack_public_path__ + "static/media/icVisibilityBlue.e60161bc38f7653c6b1dc8415f1c3862.svg";
export { ForwardRef as ReactComponent };